import { Component } from 'react';
import cx from 'classnames';
import styles from '../../styles/rent.scss';

export class MobileForm extends Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  public handleDownloadClick = (e: any) => {
    this.props.handleSubmit(e, 'mobile');
  };

  public render() {
    const { formErrors, formValid, data, handleChange } = this.props;
    return (
      <form className={cx(styles['show-in-mobile'])}>
        <div
          id="form1"
          className={cx(
            styles['rentreceipt-form'],
            styles['rentreceipt-form1']
          )}
        >
          <div>
            <div className={cx(styles['input-box'])}>
              <span className={cx(styles['error'])}>{formErrors.rent}</span>
              <input
                aria-required="true"
                name="Rent"
                type="tel"
                value={data.rent}
                onChange={handleChange}
                id="Rent"
              />
              <label className={cx(styles['active'])} htmlFor="Rent">
                What is your monthly rent?
              </label>
            </div>
          </div>
          <div>
            <div className={cx(styles['input-box'])}>
              <span className={cx(styles['error'])}>{formErrors.address}</span>
              <input
                aria-required="true"
                id="Address"
                name="Address"
                type="text"
                value={data.address}
                onChange={handleChange}
              />
              <label className={cx(styles['active'])} htmlFor="Address">
                What is the house address?
              </label>
            </div>
          </div>
        </div>
        <div
          id="form2"
          className={cx(
            styles['rentreceipt-form'],
            styles['rentreceipt-form2']
          )}
        >
          <div className={cx(styles['rentreceipt-subform'])}>
            <div className={cx(styles['input-box'])}>
              <span className={cx(styles['error'])}>{formErrors.name}</span>
              <input
                aria-required="true"
                id="Name"
                name="Name"
                type="text"
                value={data.name}
                onChange={handleChange}
              />
              <label className={cx(styles['active'])} htmlFor="Name">
                What is your name?
              </label>
            </div>
            <div className={cx(styles['input-box'])}>
              <span className={cx(styles['error'])}>{formErrors.email}</span>
              <input
                aria-required="true"
                id="UserEnteredEmail"
                name="Email"
                type="email"
                value={data.email}
                onChange={handleChange}
              />
              <label
                className={cx(styles['active'])}
                htmlFor="UserEnteredEmail"
              >
                What is your email?
              </label>
            </div>
          </div>
          <div className={cx(styles['rentreceipt-subform'])}>
            <div className={cx(styles['input-box'])}>
              <span className={cx(styles['error'])}>{formErrors.owner}</span>
              <input
                aria-required="true"
                id="HouseOwnerName"
                name="Owner"
                type="text"
                value={data.owner}
                onChange={handleChange}
              />
              <label className={cx(styles['active'])} htmlFor="HouseOwnerName">
                What is the name of your house owner?
              </label>
            </div>
            <div className={cx(styles['input-box'])}>
              <span className={cx(styles['error'])}>{formErrors.pan}</span>
              <input
                className=""
                id="HouseOwnerPan"
                name="pan"
                type="text"
                value={data.pan}
                onChange={handleChange}
              />
              <label className={cx(styles['active'])} htmlFor="HouseOwnerPan">
                What is your House Owner's PAN no (optional)?
              </label>
            </div>
          </div>
          <div className={cx(styles['rentreceipt-subform'])}>
            <p className={cx(styles['dateError'], 'text-center')}>
              {formErrors.dateError}
            </p>
            <div className={cx(styles['input-box'])}>
              <span className={cx(styles['error'])}>{formErrors.datefrom}</span>
              <input
                aria-required="true"
                id="DateFrom"
                name="DateFrom"
                placeholder="dd/mm/yyyy"
                type="text"
                value={data.datefrom}
                onChange={handleChange}
              />
              <label className={cx(styles['active'])} htmlFor="DateFrom">
                From when would you like to generate the rent receipt?
              </label>
            </div>
            <div className={cx(styles['input-box'])}>
              <span className={cx(styles['error'])}>{formErrors.dateto}</span>
              <input
                aria-required="true"
                id="DateTo"
                name="DateTo"
                placeholder="dd/mm/yyyy"
                type="text"
                value={data.dateto}
                onChange={handleChange}
              />
              <label className={cx(styles['active'])} htmlFor="DateTo">
                Till when would you like to generate the receipt?
              </label>
            </div>
          </div>
          <div className={cx(styles['input-box'], 'text-center')}>
            <button
              className={cx('btn', styles['orange-btn'], {
                [styles.disabled]: !formValid,
              })}
              value="Download"
              id="download-form-submit"
              disabled={!formValid}
              onClick={e => this.handleDownloadClick(e)}
            >
              {'Download Receipts'.toUpperCase()}
            </button>
          </div>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./components/rent/mobileForm.tsx